<template>
  <div class="search-bar">
    <input
      v-model="internalValue"
      type="text"
      v-bind="$attrs"
      @keyup.enter="onSearch"
    >
  </div>
</template>

<script>
/**
 * 검색어를 입력할 수 있는 컴포넌트 입니다.
 * @param placeholder 입력값이 없을 때 노출되는 안내 문구 입니다.
 * @param reactivity 다음 행동에 반응하여 키워드를 이벤트로 전달합니다. ['input', 'enter']
 * @param reactivityInputDelay 이벤트 반응 타입 reactivity 가 'input'인 경우 마지막 입력에 대한 딜레이를 설정합니다. 기본값: 500. 'enter' 인 경우 이 값이 무시됩니다.
 */

import {KEY_CODE} from "@/constants/keycodes";
import {cloneDeep} from "lodash";

export default {
  name: "SearchBar",
  props: {
    value: {
      type: String,
      default: undefined
    },
  },

  data() {
    return {
      internalValue: undefined
    }
  },

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.internalValue = cloneDeep(newValue)
      }
    }
  },

  methods: {
    onSearch() {
      this.$emit('input', this.internalValue)
    },
  },
}
</script>

<style scoped>
.search-bar {
  border: thin solid rgba(0, 0, 0, 0.42);
  border-radius: 4px;
  padding: 4px;
  text-align: left;
}

.search-bar input {
  width: 100%;
  padding-right: 26px;
  background: url(/img/ic_search.svg) right center no-repeat;
}

.search-bar input:focus {
  outline: none;
}
</style>
